import { ChatService } from '@messages/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MuteChannelBody, MuteChannelPathParams } from '@core-http';

export class MuteChannelCommandHandler {
  private readonly chatService: ChatService = inject(ChatService);

  mute(channelId: string, isMuted: boolean): Observable<void> {
    const pathParams: MuteChannelPathParams = { channelId };
    const payload: MuteChannelBody = { isMuted };

    return this.chatService.muteChannel(pathParams, payload);
  }
}
